// 模块 代码对应表
export const moduleMapping = {
  'ORD': '工单管理',
  'CUS': '客户管理',
  'RET': '回访管理',
  'OFF': '办公管理',
  'SPA': '备件管理',
  'PRO': '产品管理',
  'FIN': '财务管理',
  'OPE': '运营管理',
  'TEM': '模板管理',
  'POR': '企业门户',
  'AUT': '服务自动化',
  'SLA': '服务规范化',
  'OTH': '其他设置',
  'ACC': '帐户相关'
}

// 功能 代码对应表
export const funcMapping = {
  'ORD0001': '新建工单',
  'ORD0002': '工单查找',
  'ORD0003': '工单查看',
  'ORD0004': '批量导入工单',
  'ORD0005': '批量导出工单',
  'ORD0006': '模板视图导出',
  'ORD0007': '工单受理',
  'ORD0008': '工单指派',
  'ORD0009': '转派团队',
  'ORD0010': '地图派单',
  'ORD0011': '申请异常',
  'ORD0012': '异常处理',
  'ORD0013': '查看抄送工单',
  'ORD0014': '查看逾期工单',
  'ORD0015': '查看超时工单',
  'ORD0016': '取消工单',
  'ORD0017': '抄送工单',
  'ORD0018': '工单留言',
  'ORD0019': '工单打标',
  'ORD0020': '工单打印',
  'ORD0021': '接收工单',
  'ORD0022': '拒绝工单',
  'ORD0023': '预约上门',
  'ORD0024': '开始服务',
  'ORD0025': '添加进度',
  'ORD0026': '进度分配',
  'ORD0027': '结束服务',
  'ORD0028': '编辑款项',
  'ORD0029': '手写签名',
  'ORD0030': '工单回执',
  'ORD0031': '服务收款',
  'CUS0001': '新建客户',
  'CUS0002': '选择客户',
  'CUS0003': ',查找客户',
  'CUS0004': '批量导入客户',
  'CUS0005': '批量导出客户',
  'CUS0006': '客户查看',
  'CUS0007': '联系人管理',
  'CUS0008': '地址管理',
  'CUS0009': '产品档案',
  'RET0001': '查看回访单',
  'RET0002': '填写回访单',
  'RET0003': '回访计划',
  'RET0004': '生成回访单',
  'RET0005': '回访统计',
  'OFF0001': '搜索FAQ',
  'OFF0002': 'FAQ',
  'OFF0003': '搜索企业文档',
  'OFF0004': '企业文档',
  'OFF0005': '搜索企业公告',
  'OFF0006': '企业公告',
  'SPA0001': '备件商品',
  'SPA0002': '批量导入备件',
  'SPA0003': '备件库存',
  'SPA0004': '备件入库',
  'SPA0005': '备件出库',
  'SPA0006': '备件调拨',
  'SPA0007': '备件分配',
  'SPA0008': '我的备件',
  'SPA0009': '备件审批',
  'SPA0010': '库存日志',
  'SPA0011': '备件日志',
  'SPA0012': '备件日志导出',
  'PRO0001': '产品模板',
  'PRO0002': '产品',
  'FIN0001': '财务对账',
  'FIN0002': '个人佣金结算',
  'FIN0003': '个人佣金结算单导出',
  'FIN0004': '团队佣金结算',
  'FIN0005': '团队佣金结算单导出',
  'OPE0001': '企业看板',
  'OPE0002': '统计报表',
  'OPE0003': '评价报表',
  'OPE0004': '工单统计',
  'OPE0005': '营收统计',
  'OPE0006': '评价统计',
  'OPE0007': '绩效统计',
  'TEM0001': '应用模板',
  'TEM0002': '工单模板',
  'TEM0003': '进度模板',
  'TEM0004': '回执模板',
  'TEM0005': '评价模板',
  'TEM0006': '回访模板',
  'TEM0007': '模板市场',
  'TEM0008': '分享模板',
  'TEM0009': '客户模板',
  'TEM0010': '费用模板',
  'POR0001': '门户配置',
  'POR0002': '移动网站渠道接入',
  'POR0003': '钉钉服务窗渠道接入',
  'POR0004': '公众号菜单渠道接入',
  'AUT0001': '自动分配',
  'AUT0002': '自动指派',
  'AUT0003': '自动抄送',
  'SLA0001': 'SLA',
  'SLA0002': 'SLA消息通知',
  'OTH0001': '同步通讯录',
  'OTH0002': '服务项目',
  'OTH0003': '服务团队',
  'OTH0004': '人员标签',
  'OTH0005': '技能标签',
  'OTH0006': '工单标签',
  'OTH0007': '工作通知',
  'OTH0008': '短信提醒',
  'OTH0009': '短信签名',
  'OTH0010': '参数设置',
  'OTH0011': '企业付款码设置',
  'OTH0012': '进销存类型设置',
  'ACC0001': '登录'
}

/**
 * 字典表 —— 写死
 */
export const receiverType = {
  1: '单小二开放平台回调',
  11: '畅捷通开放平台回调',
  12: '钉钉开放平台回调',
  21: '微信第三方平台回调',
}



// WEBPACK FOOTER //
// ./src/constant/index.js